import { render, staticRenderFns } from "./OffersParticipantGroupTableDetails.vue?vue&type=template&id=84f11962"
import script from "./OffersParticipantGroupTableDetails.vue?vue&type=script&lang=js"
export * from "./OffersParticipantGroupTableDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports